import { FormHelperText, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { useDispatch, useSelector } from "react-redux";
import { updatePreviousOffences } from "../../redux/user/userSlice";
import { API } from "../../utils/http";
import { useTranslation } from "react-i18next";
export default function PreviousOffences(props) {
	const { handleNext, handleBack, renderControls, verifier, prefilled } = props;
	const previousOffences = useSelector((state) => state.user.application.previousOffences);
	const personalInformation = useSelector((state) => state.user.application.personalInformation);

	const [error, setError] = useState({});
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const handleNextButton = () => {
		const errors = verifier(previousOffences);
		console.log(previousOffences);
		console.log(errors);
		if (Object.keys(errors).length == 0) {
			API.put("application", {
				id: personalInformation.id,
				previousOffences: {
					offenceWithoutPardon: previousOffences,
				},
			});
			handleNext();
			setError({});
		} else {
			setError(errors);
		}
	};
	const handleChange = (e) => {
		console.log(e.target.value);
		dispatch(updatePreviousOffences(e.target.value == "true"));
	};
	return (
		<React.Fragment>
			<Grid container>
				<Grid item xs={12} marginBottom={2} whiteSpace="pre-line">
					<Typography fontWeight={"bold"}>{t("Do not declare the following:")}</Typography>
					{"\n"}
					<Typography>{t("Do Not declare line")}</Typography>
				</Grid>

				<Grid item xs={12}>
					<FormControl error={!!error.previousOffences}>
						<FormLabel style={{ fontWeight: "bolder", color: "black" }}>{t("Have you ever been convicted")}</FormLabel>
						<RadioGroup value={previousOffences} name="radio-buttons-group" onChange={handleChange}>
							<FormControlLabel value={true} control={<Radio />} label={t("Yes")} />
							<FormControlLabel value={false} control={<Radio />} label={t("No")} />
						</RadioGroup>

						<FormHelperText sx={{ display: error.previousOffences ? "initial" : "none", fontSize: "1rem" }}>{error.previousOffences}</FormHelperText>
					</FormControl>
				</Grid>
			</Grid>
			{renderControls(handleNextButton, handleBack)}
		</React.Fragment>
	);
}
